import create from 'zustand';
import { UpdateTrainingQueryState } from './interfaces/UpdateQueryState';
import { createCommonTrainingQuerySlice } from './slices/TrainingQuerySlices/CommonTrainingQuerySlice';
import { createUpdateTrainingQuerySlice } from './slices/TrainingQuerySlices/UpdateTrainingQuerySlice';

export const useUpdateTrainingQueryStore = create<UpdateTrainingQueryState>((set) => ({
  ...createCommonTrainingQuerySlice(set),
  ...createUpdateTrainingQuerySlice(set)
}));
